module.exports = __webpack_public_path__ + "img/logo.d7ad0c24.svg";